import React,{useRef, useEffect} from 'react'

import ApexCharts from 'apexcharts'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faTable, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { useParams } from "react-router-dom";


import { PageTitle } from "../../../../../_template/layout/core/PageData";

const ChatAnalytics = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');
    const pageTitle = [
        {
            title: 'Agents',
            path: loginUserType === 'SA' ? `${company}/agents/` : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        {
            title: 'Analytics',
            path: loginUserType === 'SA' ? `${company}/analytics/chat-analytics` : '/analytics/chat-analytics',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const productType = [
        { value: 'option 1', label: 'Option 1' },
        { value: 'option 2', label: 'Option 2' },
        { value: 'option 3', label: 'Option 3' },
        { value: 'option 4', label: 'Option 4' },
        { value: 'option 5', label: 'Option 5' },
    ]

    const topCardArray = [
        {
            title:'Avarage session per day',
            value: 120
        },
        {
            title:'Unique session',
            value: 32
        },
        {
            title:'Missed session',
            value: 14
        },
        {
            title:'Avarage duration',
            value: 3
        },
        {
            title:'Search interest',
            value: 31
        },
        {
            title:'Search frequency',
            value: 55
        }
    ]

    const chartRef = useRef(null);
    const refreshChart = () => {
        if (!chartRef.current) {
          return
        }
        const height = parseInt(350);
    
        const chart = new ApexCharts(chartRef.current, getChartOptions(height))
        if (chart) {
          chart.render()
        }
        return chart
    }
    useEffect(() => {
        setTimeout(() => {
            const chart = refreshChart();
            if (chart) {
                chart.updateOptions({
                    chart: { height: 350 },
                });
            }
            return () => {
                if (chart) {
                    chart.destroy();
                }
            };
        }, 200);
    }, [chartRef]);

    // ----------- project chart ----------- //

    const projectChartRef = useRef(null);

    const refreshMode = () => {
        if (!projectChartRef.current) {
          return;
        }
        const height = parseInt(350);
        const chart = new ApexCharts(projectChartRef.current, productChart(height));
        if (chart) {
          chart.render();
        }
        return chart;
    };

    useEffect(() => {
        setTimeout(() => {
            const p_chart = refreshMode();
        
            if (p_chart) {
                p_chart.updateOptions({
                    p_chart: { height: 350 },
                });
            }
        
            return () => {
                if (p_chart) {
                    p_chart.destroy();
                }
            };
        }, 200);
           
    }, [projectChartRef]);
    




    return (
        <>
            <PageTitle breadcrumbs={pageTitle}>Chat Analytics</PageTitle>
            <>
                <div className='row'>
                    {topCardArray.map(data =>
                        <div className="col-xl-4">
                            <div className="card bg-primary card-xl-stretch mb-xl-5">
                                <div className="card-body">
                                    <div className="fs-2tx fw-bolder mb-3 text-light">
                                        {data.value}
                                    </div>
                                    <div className="text-light fw-bold fs-2 mb-2 mt-5">
                                        {data.title}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </>
            <>
                <div className="row mt-5">
                    <div className='col-md-12'>
                        <div className={`card card-xl-stretch mb-xl-8 border`}>
                            <div className='card-header border-0 pt-5'>
                                <h3 className='card-title align-items-start flex-column'>
                                    <span className='card-label fw-bold fs-3 mb-1'>
                                        Session Analytics
                                    </span>
                                    <span className='text-muted fw-semibold fs-7'>More than 1000 new records</span>
                                </h3>
                                <div className="card-toolbar">
                                    <ul className="nav nav-tabs nav-line-tabs nav-stretch border-transparent fs-5 fw-bold" id="kt_security_summary_tabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className="nav-link text-active-primary active"
                                                data-kt-countup-tabs="true"
                                                data-bs-toggle="tab"
                                                data-bs-target="#kt_security_summary_tab_pane_hours"
                                                data-kt-initialized="1"
                                                aria-selected="true"
                                                role="tab"
                                            >
                                                Collective Insight
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className="nav-link text-active-primary"
                                                data-kt-countup-tabs="true"
                                                data-bs-toggle="tab"
                                                data-bs-target="#kt_security_summary_tab_pane_day"
                                                data-kt-initialized="1"
                                                aria-selected="true"
                                                role="tab"
                                            >
                                                Individual Insight
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className="row ">
                                    <div className='col-md-4'>
                                        <Select 
                                            className='react-select-styled react-select-solid' 
                                            classNamePrefix='react-select' 
                                            options={productType} 
                                            placeholder='Select an option' 
                                        />
                                    </div>
                                    <div className='col-md-4'>
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            placeholder="name@example.com"
                                        />
                                    </div>
                                    <div className='col-md-4 text-end'>
                                        <button type="button" className="btn btn-dark me-2">
                                            <FontAwesomeIcon className='me-2' icon={faMagnifyingGlass} />
                                            Search
                                        </button>

                                    
                                        <button 
                                            type="button" 
                                            className="btn btn-dark me-2"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            
                                            Export
                                            <FontAwesomeIcon className='ms-2' icon={faAngleDown} />
                                        </button>

                                        <div className='menu menu-sub menu-sub-dropdown w-200px w-md-200px' data-sai-menu='true'>
                                            <div className="row p-2">
                                                <div className="col-md-12 text-start">
                                                    <div className="menu-item px-3">
                                                        <button className="btn btn-active-light-primary menu-link">
                                                            CSV
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" className="btn btn-primary">
                                            <FontAwesomeIcon icon={faTable} className='fs-4' />
                                        </button>
                                    </div>
                                </div>
                                <div ref={chartRef} style={{height: '100%'}} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
            <>
                <div className="row mt-5">
                    <div className='col-md-12'>
                        <div className={`card card-xl-stretch mb-xl-8 border`}>
                            <div className='card-header border-0 pt-5'>
                                <h3 className='card-title align-items-start flex-column'>
                                    <span className='card-label fw-bold fs-3 mb-1'>
                                        Project Analytics
                                    </span>
                                    <span className='text-muted fw-semibold fs-7'>More than 1000 new records</span>
                                </h3>
                                <div className="card-toolbar">
                                    <ul className="nav nav-tabs nav-line-tabs nav-stretch border-transparent fs-5 fw-bold" id="kt_security_summary_tabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className="nav-link text-active-primary active"
                                                data-kt-countup-tabs="true"
                                                data-bs-toggle="tab"
                                                data-bs-target="#kt_security_summary_tab_pane_hours"
                                                data-kt-initialized="1"
                                                aria-selected="true"
                                                role="tab"
                                                >
                                                Collective Insight
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className="nav-link text-active-primary"
                                                data-kt-countup-tabs="true"
                                                data-bs-toggle="tab"
                                                data-bs-target="#kt_security_summary_tab_pane_day"
                                                data-kt-initialized="1"
                                                aria-selected="true"
                                                role="tab"
                                                >
                                                Individual Insight
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className="row ">
                                    <div className='col-md-4'>
                                        <Select 
                                            className='react-select-styled react-select-solid' 
                                            classNamePrefix='react-select' 
                                            options={productType} 
                                            placeholder='Select an option' 
                                        />
                                    </div>
                                    <div className='col-md-4'>
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            placeholder="name@example.com"
                                        />
                                    </div>
                                    <div className='col-md-4 text-end'>
                                        <button type="button" className="btn btn-dark me-2">
                                            <FontAwesomeIcon className='me-2' icon={faMagnifyingGlass} />
                                            Search
                                        </button>
                                        <button 
                                            type="button" 
                                            className="btn btn-dark me-2"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Export
                                            <FontAwesomeIcon className='ms-2' icon={faAngleDown} />
                                        </button>
                                        <div className='menu menu-sub menu-sub-dropdown w-200px w-md-200px' data-sai-menu='true'>
                                            <div className="row p-2">
                                                <div className="col-md-12 text-start">
                                                    <div className="menu-item px-3">
                                                        <button className="btn btn-active-light-primary menu-link">
                                                            CSV
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" className="btn btn-primary">
                                            <FontAwesomeIcon icon={faTable} className='fs-4' />
                                        </button>
                                    </div>
                                </div>
                                <div ref={projectChartRef} style={{height: '100%'}} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
        
    )
}

export {ChatAnalytics}

function getChartOptions() {

    const labelColor = '#A1A5B7';
    const borderColor = '#eff2f5';
    const secondaryColor = '#009ef7'
  
    return {
      series: [
        {
          name: 'Total session',
          data: [44, 55, 57, 56, 61, 58, 20, 36, 12, 18, 9, 25, 17, 71, 23],
        },
        {
          name: 'Unique session',
          data: [32, 20, 25, 45, 36, 8, 12, 6, 3 , 10, 5, 12, 6, 10, 3],
        },
        {
            name: 'missed session',
            data: [3, 2, 1, 0, 10, 23, 1, 6, 5 , 3, 8, 5, 6, 2, 3],
        },
      ],
      chart: {
        fontFamily: 'inherit',
        type: 'bar',
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 5,
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12','13', '14', '15'],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      fill: {
        opacity: 1,
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: '12px',
        },
        y: {
          formatter: function (val) {
            return val
          },
        },
      },
      colors: ['#181C32', secondaryColor, '#d9214e'],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
    }
}

function productChart() {
    const labelColor = '#A1A5B7';
    const borderColor = '#eff2f5';
    const baseColor = '#7239ea';

    return {
        series: [
            {
                name: 'Project',
                data: [
                    5, 7, 3, 2, 10, 26, 8, 4, 12, 13, 11, 15, 5, 45, 50, 35, 6, 45, 19, 25, 7, 15, 35, 5, 55, 21, 63, 7, 56,65
                ],
            },
            {
                name: 'Transfer to agent',
                data: [
                    3, 6, 1, 3, 8, 12, 10, 15, 56, 15, 19, 18, 50, 41, 21, 63, 56, 8, 65, 47, 15, 36, 15, 12, 65, 15, 10, 60, 10,25
                ],
            },
        ],
        chart: {
            fontFamily: 'inherit',
            type: 'area',
            height: 350,
            redrawOnParentResize: true,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {},
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: false,
        },
        fill: {
            type: 'solid',
            opacity: 1,
        },
        stroke: {
            curve: 'smooth',
            show: true,
            width: 3,
            colors: [baseColor],
        },
      
        xaxis: {
            categories: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21','22', '23', '24','25','26','27','28','29','30'],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
            crosshairs: {
                position: 'front',
                stroke: {
                    color: baseColor,
                    width: 1,
                    dashArray: 3,
                },
            },
            tooltip: {
                enabled: true,
                formatter: undefined,
                offsetY: 0,
                style: {
                    fontSize: '12px',
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
        },
        tooltip: {
            style: {
                fontSize: '12px',
            },
            y: {
                formatter: function (val) {
                    return val
                },
            },
        },
        // colors: [lightColor],
        colors: ['rgba(241, 241, 242, 0.7)', 'rgba(236, 248, 255, 0.7)', 'rgba(188, 253, 253, 0.7)', 'rgba(255, 245, 248, 0.7)', 'rgba(255, 248, 221, 0.7)'],
        grid: {
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },
        markers: {
            strokeColors: baseColor,
            strokeWidth: 3,
        },
    }
}